import React, { FunctionComponent } from 'react';
import { Stepper, StepperStep } from '../../../../shared/general';
import {
  CalculatorHomeValueStepperStep1,
  CalculatorHomeValueStepperStep2,
  CalculatorHomeValueStepperStep3,
  CalculatorHomeValueStepperStep4
} from './steps';
import { useIntl } from 'react-intl';
import environment from '../../../../../services/environment';

interface StepsArray {
  component: FunctionComponent<{ id: number; title?: string }>;
  hide?: boolean;
  title?: string;
}

export const CalculatorHomeValueStepper = () => {
  const intl = useIntl();
  const step1Title = intl.formatMessage({ id: 'step1.title', defaultMessage: 'Adres' });
  const step2Title = intl.formatMessage({ id: 'step2.title', defaultMessage: 'Kenmerken' });
  const step3Title = intl.formatMessage({
    id: 'step3.title',
    defaultMessage: 'Bouwjaar & Woonoppervlak'
  });
  const step4Title = intl.formatMessage({ id: 'step4.title', defaultMessage: 'Plannen' });
  const activeStep = environment.isLocal ? 0 : 0;
  const steps: StepsArray[] = [
    {
      component: CalculatorHomeValueStepperStep1,
      title: step1Title
    },
    {
      component: CalculatorHomeValueStepperStep2,
      title: step2Title
    },
    {
      component: CalculatorHomeValueStepperStep3,
      title: step3Title
    },
    {
      component: CalculatorHomeValueStepperStep4,
      title: step4Title
    }
  ];

  return (
    <Stepper
      activeStep={activeStep}
      previousButtonTexts={[step1Title, step2Title, step3Title, step4Title]}>
      {steps &&
        steps.map((step, key) => (
          <StepperStep id={key} hide={step.hide} key={key}>
            <step.component id={key} title={step.title} />
          </StepperStep>
        ))}
    </Stepper>
  );
};
